'use client';

import { Image, ZoomIn } from 'lucide-react';

import { cn } from '@/lib/utils';

type ProductTableImageCellProps = {
  src?: string | null;
  alt: string;
  placeholderLabel: string;
  zoomLabel: string;
  onPreview?: () => void;
};

export function ProductTableImageCell({
  src,
  alt,
  placeholderLabel,
  zoomLabel,
  onPreview,
}: ProductTableImageCellProps) {
  if (!src) {
    return (
      <div
        className="bg-muted text-muted-foreground flex h-10 w-10 items-center justify-center rounded border"
        aria-label={placeholderLabel}
      >
        <Image className="size-4 opacity-40" aria-hidden />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onPreview}
      aria-label={zoomLabel}
      className={cn(
        'group bg-muted relative h-10 w-10 overflow-hidden rounded border',
        'focus-visible:ring-ring focus-visible:outline-none focus-visible:ring-2',
      )}
    >
      <img src={src} alt={alt} className="h-full w-full object-cover" />
      <span className="absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition group-hover:bg-black/45 group-hover:opacity-100">
        <ZoomIn className="size-4 text-white drop-shadow-sm" aria-hidden />
      </span>
    </button>
  );
}
